import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpotlightResponseHeaderComponent } from '../shared/response-header/response-header.component';
import { SpotlightResponseFooterComponent } from '../shared/response-footer/response-footer.component';
import { getCounterIcon } from './result-counter.constants';

@Component({
    selector: 'spotlight-result-counter',
    standalone: true,
    imports: [
        CommonModule,
        SpotlightResponseHeaderComponent,
        SpotlightResponseFooterComponent
    ],
    templateUrl: './result-counter.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightResultCounterComponent {
    @Input() title: string = '';
    @Input() description: string = '';
    @Input() value: number | string = 0;
    @Input() executionTimeMs: number = 0;

    getIcon(): string {
        return getCounterIcon(this.title);
    }

    getFormattedValue(): string {
        if (typeof this.value === 'number') {
            return this.value.toLocaleString('pt-BR');
        }
        return String(this.value);
    }
}
